import { NotificationSettings } from "@/components/general/Settings/Notifications/NotificationSettings";

export default function NotificationsSettingsPage() {
    return <NotificationSettings />;
}
